import {
    ADD_NOTIFICATIONS_ACTION,
    APPOINTMENTS_LIST_ACTION,
    AVAILABILITY_ACTION,
    CLEAR_APPOINTMENT_DATA,
    CLEAR_NOTIFICATIONS_ACTION,
    CLEAR_STORE_ACTION,
    ADD_DEVICE_TO_REPAIR_ACTION,
    DEVICES_ACTION,
    ISSUES_ACTION,
    LOGIN_ERROR_ACTION,
    NOTIFICATION_VIEWED_ACTION,
    PROFILE_ACTION,
    PUSH_ADDRESS_ACTION,
    RECEIVE_APPOINTMENT_ADDRESS_ACTION,
    RECEIVE_APPOINTMENT_HOUR_SLOT_ACTION,
    RECEIVE_CARDS_ACTION,
    RECEIVE_PAYMENT_TOKEN_ACTION,
    REGISTER_ERROR_ACTION,
    REMOVE_ADDRESS_ACTION,
    REMOVE_GENERIC_NOTIFICATIONS_ACTION,
    REMOVE_NOTIFICATION_ACTION,
    REMOVE_NOTIFICATION_BY_TYPE_ACTION,
    USER_ADDRESSES_ACTION,
    USER_DEVICES_ACTION,
    USER_ZIP_CODE_ACTION,
    ZIP_CODES_ACTION
} from './fetchActions';
import {
    APTM_IN_PROGRESS_LOAD_FAILED_ACTION,
    APTM_IN_PROGRESS_LOADED_ACTION,
    APTM_IN_PROGRESS_LOADING_ACTION,
    APTM_TECH_LOCATION_UPDATE_ACTION,
} from './aptmInProgressActions';

import {
    PAYMENT_PENDING_LOAD_FAILED_ACTION,
    PAYMENT_PENDING_LOADED_ACTION,
    PAYMENT_PENDING_LOADING_ACTION,
} from './paymentOrderPendingActions';

import { NotificationType } from "../firebase/notifications/constant";

const initialState = {
    profile: null,
    devices: null,
    issues: null,
    pendingAddDevice: { issues: [] },
    availability: null,
    loginErrorText: '',
    registerErrorText: '',
    user_addresses: [],
    zip_codes: [],
    appointmentsList: [],
    cardsList: [],
    notifications: [],
    appointmentData: {
        zipCode: null,
        items: [],
        appointment_date: null,
        appointment_hour_slot_id: null,
        appointment_date_id: null,
        appointment_address: null,
        payment: null,
    },
    appointmentInProgress: {
        loading: false,
        data: null,
    },
    pendingPayment: {
        loading: false,
        data: null,
    },
};

const notificationViewedReducer = (state) => state.reduce((notifList, n) => {
    notifList.push({ ...n, isNew: false });
    return notifList;
}, []);

const removeGenericNotificationsReducer = state => state.filter(n => n.type !== NotificationType.generic);

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case PROFILE_ACTION: {
            return {
                ...state,
                profile: action.data,
            };
        }
        case DEVICES_ACTION:
            return {
                ...state,
                devices: action.data,
            };
        case ISSUES_ACTION:
            return {
                ...state,
                issues: action.data,
            };
        case AVAILABILITY_ACTION:
            return {
                ...state,
                availability: action.data,
            };
        case LOGIN_ERROR_ACTION:
            return {
                ...state,
                loginErrorText: action.data,
            };
        case REGISTER_ERROR_ACTION:
            return {
                ...state,
                registerErrorText: action.data,
            };
        case ADD_DEVICE_TO_REPAIR_ACTION:
            return {
                ...state,
                appointmentData: {
                    ...state.appointmentData,
                    items: [...state.appointmentData.items, action.data],
                },
            };
        case USER_DEVICES_ACTION:
            return {
                ...state,
                appointmentData: {
                    ...state.appointmentData,
                    items: action.data,
                },
            };
        case USER_ADDRESSES_ACTION:
            return {
                ...state,
                user_addresses: action.data,
            };
        case ZIP_CODES_ACTION:
            return {
                ...state,
                zip_codes: action.data,
            };
        case USER_ZIP_CODE_ACTION:
            return {
                ...state,
                user_zip_code: action.data,
            };
        case APPOINTMENTS_LIST_ACTION:
            return {
                ...state,
                appointmentsList: action.data,
            };
        case ADD_NOTIFICATIONS_ACTION:
            return {
                ...state,
                notifications: [
                    {
                        id: getId(state.notifications),
                        ...action.data,
                        isNew: true
                    },
                    ...state.notifications,
                ],
            };
        case NOTIFICATION_VIEWED_ACTION:
            return {
                ...state,
                notifications: notificationViewedReducer(state.notifications)
            };
        case CLEAR_NOTIFICATIONS_ACTION:
            return {
                ...state,
                notifications: [],
            };
        case REMOVE_NOTIFICATION_ACTION:
            return {
                ...state,
                notifications: state.notifications.filter(i => i.id !== action.data)
            };
        case REMOVE_GENERIC_NOTIFICATIONS_ACTION:
            return {
                ...state,
                notifications: removeGenericNotificationsReducer(state.notifications)
            };
        case PUSH_ADDRESS_ACTION:
            return {
                ...state,
                user_addresses: [...state.user_addresses, action.data],
                appointmentData: { ...state.appointmentData, appointment_address: action.data },
            };
        case REMOVE_ADDRESS_ACTION: {
            const id = action.data;
            return {
                ...state,
                user_addresses: state.user_addresses.filter(item => item.id !== id),
            }
        }
        case RECEIVE_APPOINTMENT_ADDRESS_ACTION:
            return {
                ...state,
                appointmentData: {
                    ...state.appointmentData,
                    appointment_address: action.data,
                    zipCode: action.data.address.postal_code
                },
            };
        case RECEIVE_APPOINTMENT_HOUR_SLOT_ACTION:
            return {
                ...state,
                appointmentData: !action.data ? {
                    ...state.appointmentData,
                    appointment_hour_slot_id: null,
                    appointment_date: null,
                    appointment_date_id: null
                } : {
                    ...state.appointmentData,
                    appointment_hour_slot_id: action.data.aptmHourSlot,
                    appointment_date: action.data.date,
                    appointment_date_id: action.data.dayId
                },
            };
        case RECEIVE_PAYMENT_TOKEN_ACTION:
            return {
                ...state,
                appointmentData: { ...state.appointmentData, payment: action.data },
            };
        case RECEIVE_CARDS_ACTION:
            return {
                ...state,
                cardsList: action.data
            };
        case CLEAR_APPOINTMENT_DATA: {
            return {
                ...state,
                appointmentData: {
                    zipCode: null,
                    items: [],
                    appointment_date: null,
                    appointment_hour_slot_id: null,
                    appointment_date_id: null,
                    appointment_address: null,
                    payment: null,
                },
                availability: null,
                issues: null,
            }
        }
        case APTM_IN_PROGRESS_LOADED_ACTION: {
            const { founded } = action.data;
            const aptmInProgress = { loading: false, founded };
            if (founded) {
                const { lat, lng } = action.data.current_location;
                aptmInProgress.techCurrentLocation = { lat: parseFloat(lat), lng: parseFloat(lng) };
                aptmInProgress.timeToArrive = action.data.estimated_arrival_time;
                aptmInProgress.data = action.data;
                aptmInProgress.receptionDate = Date.now();
            }
            return {
                ...state,
                appointmentInProgress: aptmInProgress
            };
        }
        case APTM_IN_PROGRESS_LOADING_ACTION:
            return {
                ...state,
                appointmentInProgress: {
                    loading: true,
                }
            };
        case APTM_IN_PROGRESS_LOAD_FAILED_ACTION:
            return {
                ...state,
                appointmentInProgress: {
                    loading: false,
                }
            };
        case APTM_TECH_LOCATION_UPDATE_ACTION:
            return {
                ...state,
                appointmentInProgress: {
                    ...state.appointmentInProgress,
                    // timeToArrive: action.data.timeToArrive,
                    techCurrentLocation: action.data.location,
                }
            };
        case REMOVE_NOTIFICATION_BY_TYPE_ACTION:
            return {
                ...state,
                notifications: state.notifications.filter(notification => notification.type !== action.data),
            };
        case PAYMENT_PENDING_LOADING_ACTION:
            return {
                ...state,
                pendingPayment: {
                    loading: true,
                }
            };
        case PAYMENT_PENDING_LOADED_ACTION: {
            const { founded } = action.data;
            return { ...state, pendingPayment: { loading: false, founded, data: action.data } }
        }
        case PAYMENT_PENDING_LOAD_FAILED_ACTION:
            return {
                ...state,
                pendingPayment: { loading: false }
            };
        case CLEAR_STORE_ACTION:
            return initialState;
        default: {
            return state
        }
    }
};

function getId(notifications) {
    if (notifications.length === 0)
        return 1;
    else {
        const step1 = notifications[notifications.length - 1].id;
        return step1 + 1;
    }
}

export default reducer;
